import { connect } from 'react-redux';

import {
  getInternalLibraryCatalog,
  isInternalLibraryLoading,
} from 'core/selectors';
import { fetchInternalLibraryCatalog } from 'core/slices/internalLibraries';

import InternalLibrariesView from '../../../components/internalLibraries/InternalLibrariesView';

export default connect(
  state => ({
    catalog: getInternalLibraryCatalog(state),
    loading: isInternalLibraryLoading(state),
  }),
  {
    fetchInternalLibraryCatalog,
  },
)(InternalLibrariesView);
